import { useState, useRef, useEffect } from "react";
import DownArrow from "../../utils/assets/down-arrow.svg";

const SelectBar = ({ dataset, defaultName, handleChange, index, inputName }) => {
  const [listData, setListData] = useState([]);
  const [isBarOpen, setIsBarOpen] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState();

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setInputValue(value);
    const filteredData = listData.filter(
      (item) =>
        (item.title && item.title.toLowerCase().includes(inputValue)) ||
        (item.name && item.name.toLowerCase().includes(inputValue))
    );
    setSearchData(filteredData);
  };

    useEffect(() => {
    setListData(dataset);
    setSearchData(dataset);
  }, [dataset]);

  function useClickOutside(callback) {
    const ref = useRef();

    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [callback]);

    return ref;
  }

  const ref = useClickOutside(() => {
    setIsBarOpen(false);
  });

  const handleSubmit = (item) => {
    setValue(item.title || item.name);
    console.log("index" , index, inputName, item.id);
    handleChange(index, inputName, item.id);
  };
  return (
    <div ref={ref}>
      <div className="card">
        <div
          className="p-2 d-flex justify-content-between align-items-center"
          onClick={() => setIsBarOpen(!isBarOpen)}
        >
          <span className="">{value ? value : defaultName}</span>
          <img src={DownArrow} width={15} alt="arrow" />
        </div>
      </div>
      {isBarOpen && (
        <div className="card position-absolute">
          <div className={`selectionContainer `}>
            <div className="m-1 d-flex justify-content-center align-items-center inputSearchBox">
              <input
                value={inputValue}
                placeholder="Type to search"
                className="form-control"
                onChange={handleSearch}
                type="text"
              />
            </div>
            <div className="d-flex flex-column" style={{ padding: "8px" }}>
              {searchData.length > 0 &&
                searchData.map((item) => {
                  return (
                    <span
                      onClick={() => {
                        handleSubmit(item);
                        setIsBarOpen(false);
                      }}
                      className={`px-2 py-1 hover_effect`}
                      key={item?.id}
                    >
                      {item?.title || item?.name}
                    </span>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectBar;
